// removed by extract-text-webpack-plugin
module.exports = {"DeliveryOrders":"DeliveryOrders__DeliveryOrders__3plaC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeliveryOrders/DeliveryOrders.css
// module id = 237
// module chunks = 1